import { gql } from "@apollo/client";

const schema = {
  current: {
    name: "unit",
    serviceName: "graphql",
    query: gql`
      query unit($ids: [String]) {
        unit(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
};

export default schema;
